import {useQuery} from "@apollo/client";
import {POSITION_ENUM} from "src/lib/queries";

export function usePositionEnum() {
  return useQuery(POSITION_ENUM);
}
